import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";

@Injectable({
  providedIn: 'root'
})

export class BranchService extends BaseRestService {

  readonly BRANCH_API_URL: string = environment.apiUri + '/branch';
  readonly BRANCH_NODE_API_URL: string = environment.apiUri + '/branch/node';
  readonly BRANCH_INTERNAL_API_URL: string = environment.apiUri + '/branch/code';

  getList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.BRANCH_API_URL, options);
  }

  getNodeList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.BRANCH_NODE_API_URL, options);
  }

  getById(id: string): Observable<any> {
    return this.httpClient.get(this.BRANCH_API_URL + "/" + id,
      { headers: this.headers });
  }

  create(data): Observable<any> {
    return this.httpClient.post(this.BRANCH_API_URL, JSON.stringify(data),
      { headers: this.headers });
  }

  update(id: string, data): Observable<any> {
    return this.httpClient.put(this.BRANCH_API_URL + "/" + id, JSON.stringify(data),
      { headers: this.headers });
  }

  createBranchNode(data): Observable<any> {
    return this.httpClient.post(this.BRANCH_NODE_API_URL, JSON.stringify(data),
        { headers: this.headers });
  }

  updateBranch(data): Observable<any> {
    return this.httpClient.put(this.BRANCH_NODE_API_URL + "/" + data.id, JSON.stringify(data),
      { headers: this.headers });
  }

  getBranchNodeById(id): Observable<any> {
    const options = {
      headers: this.headers
    }
    return this.httpClient.get(this.BRANCH_NODE_API_URL + '/' + id, options);
  }

  deleteBranchNode(id: string): Observable<any> {
    return this.httpClient.delete(this.BRANCH_NODE_API_URL + "/" + id,
        { headers: this.headers });
  }

  deleteBranch(id: string): Observable<any> {
    return this.httpClient.delete(this.BRANCH_API_URL + "/" + id,
        { headers: this.headers });
  }

  updateNode(branchType): Observable<any> {
    return this.httpClient.put(this.BRANCH_NODE_API_URL + '/' + branchType.id, JSON.stringify(branchType),
        { headers: this.headers });
  }

  getBranchByCode(code): Observable<any> {
    return this.httpClient.get(this.BRANCH_INTERNAL_API_URL + '/' + code, { headers: this.headers });
  }
}
